import { useContext } from "react";
import { UserContext } from '../context/UserContext';
import {useState, useEffect} from 'react';

export default function CompanyList() {
  const [count, setCount] = useState(100);
  //let msg = useContext(UserContext);
  //console.log("*******guillermo2222"+msg)
  return "hola";
}



